import { Autocomplete, Box, Button, Card, CardContent, CardHeader, Checkbox, Chip, FormControl, FormControlLabel, InputLabel, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { OutputTableInfo, NLCInfo } from "../../../data/interfaces/sharedmodels";
import { OutputFolder } from "../../../data/interfaces/tablegenmodels";
import { useAppDispatch } from "../../../stores/hooks";
import { useContext, useEffect, useState } from "react";
import { ReleaseTable } from "../../../data/interfaces/jobmodels";
import jobService from "../../../data/api/job.service";
import { ReleaseTableContext } from "./releasemain";



export default function ReleaseSettings() {
    const { releaseTables,setReleaseFileNames } = useContext(ReleaseTableContext);
    const [selectedReleaseTables, setSelectedReleaseTables] = useState<ReleaseTable[]>([]);
    const [selectAll, setSelectAll] = useState(false);

    useEffect(()=>{
         if(releaseTables.filter(a=>a.Version==a.OriginalVersion).length==selectedReleaseTables.length==selectAll)
         setSelectedReleaseTables(selectedReleaseTables.filter(a=>releaseTables.findIndex(b=>b.TableId==a.TableId
            &&a.StationName==b.StationName)>-1));
        setSelectAll(releaseTables.filter(a=>a.Version==a.OriginalVersion).length==selectedReleaseTables.length);
    },[releaseTables])
    const handleSelectChange = (checked: boolean, table: ReleaseTable) => {
        let tempTables = [...selectedReleaseTables];
        if (checked)
            tempTables.push(table);
        else
            tempTables.splice(tempTables.findIndex(a => a.TableId == table.TableId && a.StationName == table.StationName), 1);

        setSelectedReleaseTables(tempTables);
    }

    useEffect(() => {
            let tempTables: ReleaseTable[] = [];
            if (selectAll)
                tempTables = [...releaseTables];
            else if(selectedReleaseTables.length!=releaseTables.filter(a=>a.Version==a.OriginalVersion).length)
                tempTables=[...selectedReleaseTables.filter(a=>releaseTables.findIndex(b=>b.TableId==a.TableId&&b.StationName==a.StationName)>-1)];
            setSelectedReleaseTables(tempTables.filter(a=>a.Version==a.OriginalVersion));
        
    }, [selectAll]);

    useEffect(()=>{
        if(selectedReleaseTables.length>0){
            let taskIds:(number|null)[]=[...new Set(selectedReleaseTables.flatMap(a=>{return a.TaskId}))];
            jobService.getReleaseFileNames(taskIds).then((response)=>{
                if(response&&response.data)
                setReleaseFileNames(response.data);
            })
        }
        else{
            setReleaseFileNames([]);
        }
    },[selectedReleaseTables]);

    

    const ReleaseTableHeader=()=>{
        return(
            <Box sx={{display:'flex',justifyContent:'space-between'}}>
                <Typography variant="h6">Select Tables</Typography>
                <FormControlLabel sx={{ display: 'flex', justifyContent: 'start', mr: 2 }} labelPlacement="end"
                            control={<Checkbox checked={releaseTables.filter(a=>a.Version==a.OriginalVersion).length==selectedReleaseTables.length} onChange={(event) => setSelectAll(event.target.checked)}
                            />} label="Select All" />
                
            </Box>
        )
    }

    return (
        <Box>
            <Card >
                <CardHeader title={<ReleaseTableHeader/>} size="small"></CardHeader>
                <CardContent>
                    <TableContainer >
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell width={20}> </TableCell>
                                    <TableCell>Station</TableCell>
                                    <TableCell>Table</TableCell>
                                    <TableCell width={50}>Last Built Version</TableCell>
                                    <TableCell>Last Built Date</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {releaseTables.map((table) => {
                                    return (
                                        <TableRow >
                                            <TableCell sx={{p:'5px'}}>
                                                <Checkbox color={table.Version!=table.OriginalVersion?"error":"primary"} disabled={table.Version!=table.OriginalVersion} size="small" sx={{ width: '100%' }} onChange={(event) => handleSelectChange(event.target.checked, table)} checked={selectedReleaseTables.findIndex(a => a.TableId == table.TableId && a.StationName == table.StationName) > -1} />
                                            </TableCell >
                                            <TableCell  sx={{p:'5px',color:table.Version!=table.OriginalVersion?'orange':'inherit'}}>{table.StationName}</TableCell>
                                            <TableCell sx={{p:'5px',color:table.Version!=table.OriginalVersion?'orange':'inherit'}}>{table.TableName}</TableCell>
                                            <TableCell sx={{p:'5px',color:table.Version!=table.OriginalVersion?'orange':'inherit'}} title={table.OriginalVersion}>{table.Version}</TableCell>
                                            <TableCell sx={{p:'5px',color:table.Version!=table.OriginalVersion?'orange':'inherit'}}>{table.LastBuiltDateString}</TableCell>
                                        </TableRow>
                                    )
                                })

                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CardContent>
            </Card>
        </Box>
    )
}